import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout/index";
import Home from "@/views/boss/home/index";
/* svolt-no-permission */
import LayoutSvolt from '@/views/svolt/layout'
import HomeSvolt from '@/views/svolt/home/index'
import SvoltProject from '@/views/svolt/project/index'
import EnergyStorageCabinet from '@/views/svolt/project/wiring-diagram/energy-storage-cabinet'
import Ammeter from '@/views/svolt/project/wiring-diagram/ammeter'
import WebSocket from '@/views/svolt/project/history-data/websocket'

Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  mode: "hash",
  routes: [{
      path: "/",
      name:'Layout',
      component: Layout,
      children: [{
        path: "",
        name: "Home",
        component: Home,
        meta: {
          title: "首页"
        }
      }]
    },
    {
      path: "/webgl/:id",
      name: "webgl",
      component: () => import( /* webpackChunkName: "webgl" */ "@/views/webgl")
    },
    {
      path: "/design",
      name: "Design",
      component: () => import( /* webpackChunkName:"design" */ "@/views/design/index")
    },
    {
      path: "/localdesign",
      name: "LocalDesign",
      component: () => import( /* webpackChunkName:"localdesign" */ "@/views/localdesign/index")
    },
    {
      path: '/preview',
      name: 'Preview',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "preview" */ '@/views/design/components/Preview.vue')
    },
    // {
    //   path: "/model/:id",
    //   name: "model",
    //   component: () => import("@/views/webglmodel")
    // },
    {
      path: "/svolt",
      // name: "LayoutSvolt",
      component: LayoutSvolt,
      children: [{
          path: "/svolt",
          name: "Svolt",
          component: HomeSvolt,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/svolt/project",
          name: "SvoltProject",
          component: SvoltProject,
          meta: {
            title: "项目"
          }
        },
        {
          path: "/svolt/project/ammeter",
          name: "Ammeter",
          component: Ammeter,
          meta: {
            title: "低压侧负荷电表"
          }
        },
        {
          path: '/svolt/project/websocket',
          name: 'WebSocket',
          component: WebSocket,
          meta: {
            title: "测试WEBSOCKET"
          }
        },
        {
          path: "/svolt/project/policy",
          name: "Policy",
          component: () => import("@/views/svolt/project/policy/index"),
          meta: {
            title: "控制策略优化"
          }
        },
        {
          path: "/svolt/project/policy/detail",
          name: "PolicyDetail",
          component: () => import("@/views/svolt/project/policy/detail"),
          meta: {
            title: "控制策略详情"
          }
        },
        {
          path: "/svolt/income",
          name: "income",
          component: () => import("@/views/svolt/project/income"),
          meta: {
            title: "收益评估"
          }
        },
        {
          path: "electrovalenceConfiguration",
          name: "electrovalenceConfiguration",
          component: () => import("@/views/svolt/project/electrovalenceConfiguration.vue"),
          meta: {
            title: "电价配置"
          }
        },
        {
          path: "dataSummary",
          name: "dataSummary",
          component: () => import("@/views/svolt/project/dataSummary.vue"),
          meta: {
            title: "数据概览"
          }
        },
        {
          path: "/svolt/diagram",
          name: "diagram",
          component: () => import("@/views/svolt/project/diagram"),
          meta: {
            title: "主接线图"
          }
        },
        {
          path: "clusterOverview",
          name: "ClusterOverview",
          component: () => import("@/views/svolt/project/clusterOverview"),
          meta: {
            title: "簇总览"
          }
        },
        {
          path: "pileOverview",
          name: "PileOverview",
          component: () => import("@/views/svolt/project/pileOverview"),
          meta: {
            title: "堆总览"
          }
        },
        {
          path: "pileOverviewChart",
          name: "PileOverviewChart",
          component: () => import("@/views/svolt/project/pileOverviewChart"),
          meta: {
            title: "堆曲线查询"
          }
        },
        {
          path: "pcsCurveQuery",
          name: "PcsCurveQuery",
          component: () => import("@/views/svolt/project/pcsCurveQuery"),
          meta: {
            title: "PCS曲线查询"
          }
        },
        {
          path: "pcsOverview",
          name: "PcsOverview",
          component: () => import("@/views/svolt/project/pcsOverview"),
          meta: {
            title: "PCS总览"
          }
        },
        {
          path: "centralizedPcsDetail",
          name: "centralizedPcsDetail",
          component: () => import("@/views/svolt/project/pcs-overview/centralizedPcsDetailWrap"),
          meta: {
            title: "PCS详情"
          }
        },
        {
          path: "centralizedPcsDetailX",
          name: "centralizedPcsDetailX",
          component: () => import("@/views/svolt/project/pcs-overview/centralizedPcsDetailWrapX"),
          meta: {
            title: "PCS详情"
          }
        },
        {
          path: "airDetail",
          name: "AirDetail",
          component: () => import("@/views/svolt/project/pcs-overview/airWrap"),
          meta: {
            title: "实时空调"
          }
        },
        {
          path: "meter",
          name: "Meter",
          component: () => import("@/views/svolt/project/pcs-overview/meterWrap"),
          meta: {
            title: "实时电表"
          }
        },
        {
          path: "communicationStatus",
          name: "CommunicationStatus",
          component: () => import("@/views/svolt/project/communicationStatus"),
          meta: {
            title: "设备通讯状态"
          }
        },
        {
          path: "historyData",
          name: "HistoryData",
          component: () => import("@/views/svolt/project/historyData"),
          meta: {
            title: "全量数据"
          }
        },
        {
          path: "typicalDaily",
          name: "TypicalDaily",
          component: () => import("@/views/svolt/project/typicalDaily"),
          meta: {
            title: "典型日报"
          }
        },
        {
          path: "clusterElectricCoreMonth",
          name: "ClusterElectricCoreMonth",
          component: () => import("@/views/svolt/project/clusterElectricCoreMonth"),
          meta: {
            title: "月度电芯"
          }
        },
        {
          path: "clusterElectricCoreYear",
          name: "ClusterElectricCoreYear",
          component: () => import("@/views/svolt/project/clusterElectricCoreMonth"),
          meta: {
            title: "年度电芯"
          }
        },
        {
          path: "newsCenter",
          name: "NnewsCenter",
          component: () => import("@/views/svolt/project/newsCenter"),
          meta: {
            title: "告警列表"
          }
        },
        {
          path: "energyStorageCatinet",
          name: "EnergyStorageCatinet",
          component: () => import("@/views/svolt/project/energyStorageCatinet"),
          meta: {
            title: "储能柜"
          }
        },
        {
          path: "cellMonitoring",
          name: "cellMonitoring",
          component: () => import("@/views/svolt/project/cellMonitoring"),
          meta: {
            title: "电芯监控"
          }
        },
        {
          path: "fullDownload",
          name: "fullDownload",
          component: () => import("@/views/svolt/project/fullDownload"),
          meta: {
            title: "簇下载"
          }
        },
        {
          path: "fullDownloadList",
          name: "fullDownloadList",
          component: () => import("@/views/svolt/project/fullDownloadList"),
          meta: {
            title: "全量下载"
          }
        },
        {
          path: "downloadList",
          name: "downloadList",
          component: () => import("@/views/svolt/project/downloadList"),
          meta: {
            title: "下载列表"
          }
        },
        {
          path: "electricEnergyAnalysis",
          name: "electricEnergyAnalysis",
          component: () => import("@/views/svolt/project/electricEnergyAnalysis"),
          meta: {
            title: "电能分析"
          }
        },
        {
          path: "/svolt/ewm",
          name: "ewm",
          component: () => import("@/views/svolt/project/ewm"),
          meta: {
            title: "app下载二维码"
          }
        },
        {
          path: "replaceMeter",
          name: "replaceMeter",
          component: () => import("@/views/svolt/project/replaceMeter"),
          meta: {
            title: "换表记录"
          }
        },
        {
          path: "userElectrovalence",
          name: "userElectrovalence",
          component: () => import("@/views/svolt/project/userElectrovalence"),
          meta: {
            title: "用户电价"
          }
        },
        {
          path: "settlement",
          name: "settlement",
          component: () => import("@/views/svolt/project/settlement.vue"),
          meta: {
            title: "结算列表"
          }
        },
        {
          path: "timezone",
          name: "timezone",
          component: () => import("@/views/svolt/project/timezone.vue"),
          meta: {
            title: "时区时段"
          }
        },
        {
          path: "controlOperationLog",
          name: "controlOperationLog",
          component: () => import("@/views/svolt/project/controlOperationLog.vue"),
          meta: {
            title: "控制操作日志"
          }
        },
        {
          path: "policyManagement",
          name: "policyManagement",
          component: () => import("@/views/svolt/project/policyManagement.vue"),
          meta: {
            title: "策略管理"
          }
        },
        {
          path: "energyManagement",
          name: "energyManagement",
          component: () => import("@/views/svolt/project/energyManagement.vue"),
          meta: {
            title: "能量管理"
          }
        },
        {
          path: "deviceControl",
          name: "deviceControl",
          component: () => import("@/views/svolt/project/deviceControl.vue"),
          meta: {
            title: "设备控制"
          }
        },
        {
          path: "electricQuantityAnalysis",
          name: "electricQuantityAnalysis",
          component: () => import("@/views/svolt/project/electricQuantityAnalysis.vue"),
          meta: {
            title: "电量分析"
          }
        },
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/login/index")
    },
    {
      path: "/system",
      name: "System",
      component: () => import("@/views/login/system")
    },
    {
      path: "/404",
      name: "NoPage",
      component: () => import("@/views/error-page/404"),
      hidden: true
    },
    {
      path: "/401",
      name: "NoPermission",
      component: () => import("@/views/error-page/401"),
      hidden: true
    },
    {
      path: "/workOrder",
      name: "workOrder",
      component: () =>
        import("@/views/svolt/project/intelligentDevOps/workOrder"),
      hidden: true
    },
    {
      path: "/knowledgeGraph",
      name: "knowledgeGraph",
      component: () =>
        import("@/views/svolt/project/intelligentDevOps/knowledgeGraph"),
      hidden: true
    },
    {
      path: "/transactionDetails",
      name: "transactionDetails",
      component: () =>
        import("@/views/svolt/project/transactionDetails/transactionDetails"),
      hidden: true
    },
    {
      path: '/messageCenter',
      name: 'messageCenter',
      component: () => import('@/views/svolt/project/messageCenter/messageCenter'),
      hidden: true
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js